import { clizsec, scamatrix } from "./discoverability";

export const product = {
    name: scamatrix.name,
    tagline: "AI Powered Threat Intelligence Lookup Service",
    supportEmail: "support@scamatrix.com",
    securityEmail: "security@scamatrix.com",
    twitterHandle: "@ScaMatrix",
} as const;

export const creator = {
    name: "Mark Liapustin (clizSec)",
    url: clizsec.canonicalEnglish,
    github: "https://github.com/clizsec",
    linkedIn: "https://www.linkedin.com/in/clizsec",
} as const;

export const social = [
    {
        name: "X",
        link: "https://x.com/ScaMatrix",
    },
    {
        name: "LinkedIn",
        link: "https://www.linkedin.com/company/scamatrix/",
    },
    {
        name: "Facebook",
        link: "https://www.facebook.com/scamatrix",
    },
    {
        name: "clizSec",
        link: clizsec.canonicalEnglish,
    },
    {
        name: "GitHub",
        link: creator.github,
    },
] as const;
